<template>
    <div class="caseApply">
        <div class="caseApplyHead">
            <!-- <div class="caseApplyTitle">病案复印助手</div> -->
            <van-steps :active="active" active-color="#fff">
                <van-step>复印申请</van-step>
                <van-step>身份认证</van-step>
                <van-step>复印信息</van-step>
                <van-step>支付结算</van-step>
            </van-steps>
            <div class="chooseHospitalDiv">
                <span class="hospitalLogo" v-bind:style="{backgroundImage:'url(' + hospitalObj.orgLogo + ')','background-repeat': 'no-repeat','background-size': '70%','background-position':'center'}"></span>
                <span class="hospitalName" id="hospitalName">{{hospitalObj.orgName}}</span>
                <!-- <span class="hospitalGG" @click="getOrgdes"><van-icon name="password-view" />&nbsp;复印公告</span> -->
                <!-- <span class="chooseHospital" @click="goMain">医院<van-icon name="arrow" /></span> -->
                <span class="hospitalGG" @click="getOrgdes">
                    <a class="noticeIcon"></a>公告</span>
                <span class="hospitalGG" @click="telPhone">
                    <a class="helpIcon"></a>帮助</span>
                <span class="hospitalGG" @click="myOrders">
                    <a class="orderIcon"></a>订单</span>
            </div>
        </div>
        <div class="caseApplyType">复印病案类型</div>
        <div class="caseApplyTypeNav">
            <div v-for="it in hospitalObj.caseList" :key="it.serviceId" style="float:left;">
                <span class="ApplyTypeNav" v-if="it.serviceId=='4'" :class="ApplyTypeNavFlag1?'active':''" @click="selectCase(it.serviceId)">{{it.serviceName}}</span>
                <span class="ApplyTypeNav" v-else-if="it.serviceId=='5'" :class="ApplyTypeNavFlag2?'active':''" @click="selectCase(it.serviceId)">{{it.serviceName}}</span>
                <span class="ApplyTypeNav" v-else-if="it.serviceId=='6'" :class="ApplyTypeNavFlag3?'active':''" @click="selectCase(it.serviceId)">{{it.serviceName}}</span>
            </div>

            <!-- <span class="ApplyTypeNav" v-for="it in hospitalObj.caseList" :key="it.serviceId"  v-if="it.serviceId=='4'" @click="selectCase('4')" :class="ApplyTypeNavFlag1?'active':''">住院病案</span>
            <span class="ApplyTypeNav" v-for="it in hospitalObj.caseList" :key="it.serviceId"  v-if="it.serviceId=='5'" @click="selectCase('5')" :class="ApplyTypeNavFlag2?'active':''">急诊病案</span>
            <span class="ApplyTypeNav" v-for="it in hospitalObj.caseList" :key="it.serviceId"  v-if="it.serviceId=='6'" @click="selectCase('6')" :class="ApplyTypeNavFlag3?'active':''">门诊病案</span> -->
        </div>
        <div class="caseApplyType">复印获取</div>
        <div class="caseApplyTypeNav">
            <div v-for="it in hospitalObj.serviceList" :key="it.serviceId" style="float:left;">
                <span class="ApplyTypeNav" v-if="it.serviceId=='2'" :class="ApplyTypeNavFlag22?'active':''"  @click="selectCase1(it.serviceId)">{{it.serviceName}}</span>
                <span class="ApplyTypeNav" v-else-if="it.serviceId=='3'" :class="ApplyTypeNavFlag33?'active':''"  @click="selectCase1(it.serviceId)">{{it.serviceName}}</span>
            </div>

            <!-- <span class="ApplyTypeNav" v-for="it in hospitalObj.serviceList" :key="it.serviceId"  v-if="it.serviceId=='3'" @click="selectCase1('3')" :class="ApplyTypeNavFlag22?'active':''">自提</span>
            <span class="ApplyTypeNav" v-for="it in hospitalObj.serviceList" :key="it.serviceId"  v-if="it.serviceId=='1'" @click="selectCase1('1')" :class="ApplyTypeNavFlag33?'active':''">预约自提</span> -->
        </div>
        <div class="caseApplyType" v-if="isSendFlag">邮寄信息</div>
        <ul v-if="isSendFlag">
            <li class="caseApplyMessage"><span>收件人</span><input type="text" v-model="ruleForm.Addressee" placeholder="请输入收件人姓名"></li>
            <li class="caseApplyMessage">
                <span>手机号码</span>
                <input type="text" maxlength="11" @blur="checkPhone" v-model="ruleForm.phoneNum" placeholder="请输入手机号码">
            </li>
            <li class="caseApplyMessage"><span>所在区域</span><input type="text" readonly v-model="ruleForm.addressName" placeholder="请输入省市区" @click="openProvinceCityVillage"></li>
            <li class="caseApplyAddress"><span>详细地址</span><textarea v-model="ruleForm.addressDescName" placeholder="请详细到门排号"></textarea></li>
        </ul>
        <div class="caseApplyMark"><span>注</span>为保证及时收到病历，请准确填写邮寄信息！快递公司由《{{hospitalObj.postName}}》承揽</div>
        <div class="caseApplyFooter">
            <input type="button" value="下一步" @click="goCaseSecond" :disabled="btnFlag" :class="btnFlag?'':'btnactive'">
        </div>
        <div class="hospitalPopup" v-show="hospitalPopupFlag">
                <div class="caseApplyTitle">{{hospitalObj.orgName}}</div>
                <div class="caseApplyDesc">
                    <a></a><span>申请须知</span><a></a>
                </div>
                <div class="caseApplyDescTitle">
                    病案助手微信公众号办理住院病历复印邮寄
                    <p>知情同意书</p>
                </div>
            <div class="hospitalNoticeTxt">
                <h4>尊敬的患者和家属：</h4>
                <div v-html="orgDes"></div>
            </div>
            <div class="hospitalFooter">
                <div class="readAndAgree">
                    <van-checkbox v-model="checked" checked-color="#1C84F2"></van-checkbox><span @click="radioChecked">已阅读并同意《<a>授权协议</a>》</span>
                </div>
                <div class="caseApplyFooter">
                    <input type="button" value="取消" @click="goMain" class="cancleBtn">
                    <input type="button" value="同意" @click="closeHospitalPopup" class="confirmBtn" :disabled="arragrFlag" :class="arragrFlag?'':'btnactive'">
                </div>
            </div>

        </div>
         <div class="caseApplyBg" v-show="hospitalPopupFlag"></div>
         <div class="caseApplyBg" v-show="provinceCityVillageFlag" @click="closeProvinceCityVillage"></div>
         <van-area :area-list="areaList" :columns-num="3" title="选择省市县" v-show="provinceCityVillageFlag" @confirm="getProvinceCityVillage" @cancel="closeProvinceCityVillage"/>
    </div>
</template>
<script>
import {Toast} from 'vant'
import provinceCityVillage from '@/assets/js/provinceCityVillage'
import ApiSetting from '@/assets/js/api'
export default {
  data(){
        return{
            active: 0,
            orgDes:'',
            checked:false,
            hospitalPopupFlag:true,
            hospitalObj:"",
            provinceCityVillageFlag:false,
            areaList:{},
            ruleForm:{
                Addressee:'',//收件人
                phoneNum:'',//手机号
                addressName:'',//城市,
                addressDescName:'',//详细地址
                phoneNumFlag:false,
                stateId:'',//省ID
                stateName:'',
                cityId:'',//市ID
                cityName:'',
                districtId:'',//区/县ID
                districtName:'',
                serviceList:{
                    serviceId:'2',
                    serviceName:'邮寄'
                },
                caseList:{
                    caseId:'4',
                    caseName:'住院病案'
                }
            },
            btnFlag:true,
            arragrFlag:true,
            isSendFlag:true,
            ApplyTypeNavFlag1:true,
            ApplyTypeNavFlag2:false,
            ApplyTypeNavFlag3:false,
            ApplyTypeNavFlag11:false,
            ApplyTypeNavFlag22:true,
            ApplyTypeNavFlag33:false,
        }
    },
    created(){
      //此申请页面单独嵌入到医院公众号时处理 开始
      let code = this.$utils.getUrlKey("code");
      if (code != undefined) {
        this.$http.get(ApiSetting.getOpenId + code).then((response) => {
        })
      }
      //单独获取机构信息
      let uuid = this.$utils.getUrlKey("uuid");
      if (uuid != undefined) {
        this.getOnlineOrg(uuid)
      } else if (null != sessionStorage.getItem('obj')){
        this.hospitalObj=JSON.parse(sessionStorage.getItem('obj'))
      }
      //此申请页面单独嵌入到医院公众号时处理 结束
        this.areaList=provinceCityVillage
    },
    watch:{
        'ruleForm': {
            handler(newValue, oldValue) {
                if(newValue.serviceList.serviceId=='2'){
                    if(newValue.Addressee==""
                    ||newValue.phoneNum==""
                    ||newValue.addressName==""
                    ||newValue.addressDescName==""
                    ||newValue.serviceList.serviceId==""
                    ||newValue.caseList.caseId==""){
                        this.btnFlag=true
                    }else{
                        if(newValue.phoneNumFlag){
                            this.btnFlag=false
                        }else{
                            this.btnFlag=true
                        }

                    }
                }else{
                    this.btnFlag=false
                }

            },
            deep: true
        },
        // 'ruleForm.serviceList':{
        //     handler(newValue, oldValue) {
        //         if(newValue.serviceId=='2'){
        //             this.btnFlag=true
        //         }else{
        //             this.btnFlag=false
        //         }
        //     },
        //     deep: true
        // },
        'checked':function(val){
            if(val==true){
                this.arragrFlag=false
            }else{
                this.arragrFlag=true
            }
        }
    },
    mounted(){
      this.openHospitalPopup()
    },
    methods:{
        telPhone(){
            Dialog.confirm({
                title: '帮助',
                message: '客服电话：010-85775003',
                confirmButtonText:'呼叫',
                confirmButtonColor:'#1C84F2'
                }).then(() => {
                // on confirm
                window.location.href = "tel://010-85775003"
                }).catch(() => {
                // on cancel
            });
            //window.location.href = "tel://010-85775003";
        },
        myOrders(){
            this.$router.push({path: '/myOrder'})
        },
        radioChecked(){
            this.checked=!this.checked
        },
        getProvinceCityVillage(columnsNum){
            this.ruleForm.stateId=columnsNum[0].code
            this.ruleForm.cityId=columnsNum[1].code
            this.ruleForm.districtId=columnsNum[2].code
            this.ruleForm.stateName=columnsNum[0].name
            this.ruleForm.cityName=columnsNum[1].name
            this.ruleForm.districtName=columnsNum[2].name
            this.ruleForm.addressName=columnsNum[0].name+""+columnsNum[1].name+""+columnsNum[2].name
            this.provinceCityVillageFlag=false
        },
        openProvinceCityVillage(){
            this.provinceCityVillageFlag=true
        },
        closeProvinceCityVillage(){
            this.provinceCityVillageFlag=false
        },
        checkPhone(){
            var _this=this
            if(!(/^1[3456789]\d{9}$/.test(this.ruleForm.phoneNum))){
                Toast('手机号格式错误')
                // this.errorTitleFlag=true
                // setTimeout(function(){
                //     _this.errorTitleFlag=false
                // },2000)
                this.ruleForm.phoneNumFlag=false
            }else{
                this.ruleForm.phoneNumFlag=true
            }
        },
        selectCase(num){
            if(num=='4'){
                this.ApplyTypeNavFlag1=true
                this.ApplyTypeNavFlag2=false
                this.ApplyTypeNavFlag3=false
                this.ruleForm.caseList.caseId=num
                this.ruleForm.caseList.caseName='住院病案'
            } else if(num=='5'){
                this.ApplyTypeNavFlag1=false
                this.ApplyTypeNavFlag2=true
                this.ApplyTypeNavFlag3=false
                this.ruleForm.caseList.caseId=num
                this.ruleForm.caseList.caseName='急诊病案'
            } else if(num=='6'){
                this.ApplyTypeNavFlag1=false
                this.ApplyTypeNavFlag2=false
                this.ApplyTypeNavFlag3=true
                this.ruleForm.caseList.caseId=num
                this.ruleForm.caseList.caseName='门诊病案'
            }
        },
        selectCase1(num){
            if(num=='3'){
                this.ApplyTypeNavFlag11=false
                this.ApplyTypeNavFlag22=false
                this.ApplyTypeNavFlag33=true
                this.isSendFlag=false
                this.ruleForm.serviceList.serviceId=num
                this.ruleForm.serviceList.serviceName='预约自提'
            }else if(num=='2'){
                this.ApplyTypeNavFlag11=false
                this.ApplyTypeNavFlag22=true
                this.ApplyTypeNavFlag33=false
                this.isSendFlag=true
                this.ruleForm.serviceList.serviceId=num
                this.ruleForm.serviceList.serviceName='邮寄'
            }
            // else if(num=='3'){
            //     this.ApplyTypeNavFlag11=false
            //     this.ApplyTypeNavFlag22=true
            //     this.ApplyTypeNavFlag33=false
            //     this.isSendFlag=false
            //     this.ruleForm.serviceList.serviceId=num
            //     this.ruleForm.serviceList.serviceName='自取'
            // }
        },
        goCaseSecond(){
            sessionStorage.setItem('casePathMessage',JSON.stringify(this.ruleForm))
            if ('6' == this.ruleForm.caseList.caseId) {
                this.$router.push({path: '/caseApplySecond1'}) // 门诊专用页面
            } else {
                this.$router.push({path: '/caseApplySecond'})
            }
        },
        goMain(){
          this.closeHospitalPopup();
            //此页面对外提供，防止对外医院列表防止对外刷数据
          let uuid = this.$utils.getUrlKey("uuid");
          if (uuid !=undefined) {
              return
            }
            this.$router.push({path: '/main'})
        },
        //复印须知
        openHospitalPopup(){
            this.hospitalPopupFlag=localStorage.getItem(this.hospitalObj.orgUUId + 'hospitalPopupFlag')
            if(this.hospitalPopupFlag=="false"){
                this.hospitalPopupFlag=false
            }else{
                this.getOrgdes()
            }
        },
        getOrgdes(){
            let uuid = this.hospitalObj.orgUUId;
            if (uuid == undefined) {
                uuid = this.$utils.getUrlKey("uuid");
            }
            var param={
                uuid:uuid
            }
            this.postRequest(ApiSetting.orgdes,param).then((res) => {
                if(res.data.responseCode=='200'){
                    this.orgDes=res.data.orgDes
                    this.hospitalPopupFlag=true
                }
            })
        },
        closeHospitalPopup(){
            this.hospitalPopupFlag=false
            localStorage.setItem(this.hospitalObj.orgUUId + 'hospitalPopupFlag',this.hospitalPopupFlag)
        },
        getOnlineOrg(uuid){
          var param = {
            uuid: uuid
          }
          this.postRequest(ApiSetting.queryOnlineOrgByUuid, param).then((res) => {
            if (res.data.responseCode == '200') {
              this.hospitalObj = res.data.data
              console.info(this.hospitalObj)
              sessionStorage.setItem('obj', JSON.stringify(this.hospitalObj))
            }
          })
        }
    }
}
</script>
<style lang="less">
.van-steps{
    background-color: #1C84F2 !important;
}
.van-steps__items{
    margin: 0 !important;
}
.caseApply .van-step{
    color: #fff !important;
}
// .van-step__title{
//     color: #fff !important;
// }
// .van-step--horizontal.van-step--finish .van-step__circle, .van-step--horizontal.van-step--finish .van-step__line{
//     background-color:#ffffff !important;
// }
.van-step .van-step__circle{
    background-color:#ffffff !important;
}
/deep/
.van-icon-checked{
    color: #ffffff !important;
}
.van-step__circle-container{
    background-color: #1C84F2 !important;
}
.van-area{
    position: fixed !important;
    bottom: 0;
    width: 100%;
    z-index: 99;
}
.errorTitle{
    background:#ff0000;
    color: #ffffff;
    height: 1rem;
    line-height: 1rem;
    position: fixed;
    top: 0rem;
    left: 0;
    width: 100%;
    font-size: 0.32rem;
    text-align: center;
}
.caseApplyBg{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0.6;
    background: #000000;
    z-index: 10;
}
.hospitalPopup{
    height:80%;
    width: 90%;
    background: #ffffff;
    position: fixed;
    top: 10%;
    left: 5%;
    overflow: hidden;
    z-index: 20;
    border-radius: 0.2rem;

    h4{
        height: 0.6rem;
        line-height: 0.6rem;
        padding: 0;
        margin: 0;
        color: #333;

    }
    .caseApplyDescTitle{
        width: 100%;
        text-align: center;
        color:#333;
        font-weight: 600;
        font-size: 0.28rem;
        height: 1.2rem;
        p{
            height: 0.6rem;;
            line-height: 0.6rem;
            margin: 0;
        }
    }
    .caseApplyDesc{
        width: 90%;
        height: 0.6rem;
        line-height: 0.6rem;
        margin: 0 auto;
        a,span{
            display: inline-block;
            float: left;
        }
        span{
            width: 20%;
            text-align: center;
            color:#333;
            font-weight: 600;
            margin: 0 5%;
            font-size: 0.28rem;
        }
        a{
            height: 1px;
            width: 35%;
            background: #ccc;
            margin-top: 0.3rem;
        }
    }
    .caseApplyTitle{
        height: 1rem;
        line-height: 1rem;
        width: 100%;
        text-align: center;
        font-size: 0.4rem;
        background:#1C84F2;
        color: #fff;
    }
    .hospitalNoticeTxt{
        height: 56%;
        padding:0 0.4rem;
        overflow: auto;
        font-size: 0.28rem;
        line-height: 0.4rem;
        position: relative;
        bottom: 0.2rem;
        background: #fafafa;
        p{
            color:#666666;
            margin: 0;
            line-height: 0.5rem;
        }
    }
    .hospitalFooter{
        background: #ffffff;
        position: fixed;
        height: 2rem;
        width: 90%;
        bottom: 10%;
        span{
            height: 0.6rem;
            line-height: 0.6rem;
        }
        /deep/
        .van-checkbox__icon .van-icon{
            border: 1px solid #999999 !important;
            width: 0.32rem;
            height: 0.32rem;
            line-height:0.32rem;
            margin-top:0 !important;
            margin: 0rem;
            appearance: none;
            -webkit-appearance: none;
        }
        .confirmBtn,.cancleBtn{
            width: 30%;
            height: 0.8rem;
            line-height: 0.8rem;
            border: none;
            color: #ffffff;
            background: #cccccc;
            margin-left: 13.3%;
        }
    }
}
.readAndAgree{
    font-size: 0.24rem;
    color: #999999;
    height: 0.6rem;
    line-height: 0.6rem;
    background:#ffffff;
    width:100%;
    .van-checkbox{
        float: left;
        margin-right: 0.1rem;
        margin-left:5%;
        /deep/
        .van-checkbox__icon--checked .van-icon{
            border-color: #1C84F2 !important;
            background-color: #1C84F2 !important;
        }
        /deep/
        .van-checkbox__icon .van-icon{
            border: 1px solid #999999 !important;
            width: 0.32rem;
            height: 0.32rem;
            margin-top: 0.1rem;
        }
    }
    span{
        display: inline-block;
        float: left;
        a{
            color: #1C84F2;
        }
    }
}
.caseApply{
    .caseApplyHead{
        background:#1C84F2;
        height: auto;
        width: 100%;
        .caseApplyTitle{
            font-size: 0.4rem;
            font-weight: 600;
            width: 100%;
            height:1rem;
            line-height: 1rem;
            text-align: center;
            color: #ffffff;
        }
        .van-step--horizontal .van-step__title{
            font-size: 0.28rem;
        }
        .chooseHospitalDiv{
            height: 1rem;
            line-height: 1rem;
            background: #ffffff;
            color: #333333;
            //border-top: 1px solid #e4e4e4;
            .hospitalLogo{
                font-size: 0.28rem;
                display: inline-block;
                float: left;
                width: 0.86rem;
                height: 0.86rem;
                margin-top: 0.06rem;
                margin-left: 0.2rem;
                margin-right: 0.2rem;
                //background: #1C84F2;
            }
            .hospitalName{
                font-size: 0.28rem;
                display: inline-block;
                float: left;
                font-weight: 600;
            }
            .chooseHospital{
                font-size: 0.28rem;
                display: inline-block;
                float: right;
                margin-right: 0.2rem;
                .van-icon{
                    margin-top: 0.36rem;
                    height: 0.28rem;
                    margin-right:0.2rem;
                    float: right;
                }
            }
            .hospitalGG{
                font-size: 0.28rem;
                display: inline-block;
                float: left;
                color: #1C84F2;
                .van-icon{
                    margin-top: 0.36rem;
                    height: 0.28rem;
                    margin-left:0.2rem;
                    float: left;
                }
            }
        }
    }
    .caseApplyType{
        height: 0.8rem;
        line-height: 0.8rem;
        font-size: 0.28rem;
        color: #333333;
        padding-left: 0.2rem;
    }
    .caseApplyTypeNav{
        height: 1rem;
        line-height: 1rem;
        font-size: 0.28rem;
        background: #ffffff;
        padding-left: 0.2rem;
    }
    .ApplyTypeNav{
        width: 2rem;
        height: 0.8rem;
        line-height: 0.82rem;
        display: inline-block;
        background: #dfdfdf;
        margin-left: 0.2rem;
        text-align: center;
        color: #333333;
        border-radius: 0.1rem;
        &.active{
            background: #1C84F2;
            color: #ffffff
        }
    }
    #hospitalName{
        width: 3.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .caseApplyMessage{
        height: 1rem;
        line-height: 1rem;
        font-size: 0.28rem;
        color: #333333;
        background: #ffffff;
        padding-left: 0.2rem;
        border-bottom: 1px solid #e4e4e4;
        position: relative;
        span{
            display: inline-block;
            float: left;
            // margin-right: 0.2rem;
            height: 1rem;
            line-height: 1rem;
            // margin-top: 0.2rem;
        }
        input{
            position: absolute;
            display: inline-block;
            height: 0.6rem;
            line-height: 0.6rem;
            top: 0.15rem;
            left: 2rem;
            border:none;
            width: 5rem;
            outline: none;
        }
    }
    .caseApplyAddress{
        height: 1.6rem;
        line-height: 0.8rem;
        font-size: 0.28rem;
        color: #333333;
        background: #ffffff;
        padding-left: 0.2rem;
        border-bottom: 1px solid #e4e4e4;
        position: relative;
        textarea{
            position: absolute;
            left: 2rem;
            line-height: 0.7rem;
            border: none;
            resize: none;
            height: 1.5rem;
            width:5rem;
        }
    }
    .caseApplyFooter{
        clear: both;
        height: 1.2rem;
        line-height: 0.7rem;
        width: 100%;
        background: #ffffff;
        .btnactive{
            background: #1C84F2;
        }
        input{
            height: 0.8rem;
            line-height:0.8rem;
            font-size: 0.32rem;
            background: #cccccc;
            color: #ffffff;
            width: 90%;
            display: inline-block;
            margin-left: 5%;
            border: none;
            border-radius: 0.1rem;
        }
    }
    .caseApplyMark{
        font-size: 0.28rem;
        line-height: 0.6rem;
        margin-left: 0.2rem;
        color: #333;
        span{
            color: #ffffff;
            background: #1C84F2;
            display: inline-block;
            width: 0.6rem;
            height: 0.4rem;
            line-height: 0.4rem;
            text-align: center;
            margin-top: 0.2rem;
            border-radius: 0.1rem;
            margin-right: 0.2rem;
        }
    }
    .van-step{
        color: #333333;
    }
}

</style>

